import { useState } from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

export default function ImageWithSkeleton({
  src,
  alt,
  ring = true,
  aspect = 'aspect-[2/3]',
  rounded = 'rounded-xl',
  object = 'object-cover',
  className = '',
  fallback = '/placeholder.jpg',
  skeletonProps = {},
  ...imgProps
}) {
  const [loaded, setLoaded] = useState(false);
  const [err, setErr] = useState(false);

  return (
    <div className={`relative w-full ${aspect} ${rounded} overflow-hidden bg-gray-100`}>
      {!loaded && (
        <Skeleton
          className="absolute inset-0 h-full w-full"
          containerClassName="h-full w-full"
          {...skeletonProps}
        />
      )}

      <img
        src={err ? fallback : src}
        alt={alt}
        onLoad={() => setLoaded(true)}
        onError={() => {
          setErr(true);
          setLoaded(true);
        }}
        className={`${object} h-full w-full transition-opacity duration-300 ${
          loaded ? 'opacity-100' : 'opacity-0'
        } ${className}`}
        loading="lazy"
        {...imgProps}
      />

      {ring && (
        <div
          className={`pointer-events-none absolute inset-0 ${rounded} ring-1 ring-gray-900/10 ring-inset`}
        />
      )}
    </div>
  );
}
